import axios from "axios";
import ApiUrls from "../../constants/ApiUrls";

export default {
  getOpfs() {
    return axios.get(`/Nsi/Opfs`, {});
  },
  getOrganizationTypes() {
    return axios.get(`/Nsi/OrganizationTypes`, {});
  },
  getBudgetOrgs() {
    return axios.get(`/Nsi/BudgetOrgs`, {});
  },
  getIogvs() {
    return axios.get(`/Nsi/Iogvs`, {});
  },
  getFias(value) {
    return axios.get(
      ApiUrls.webApiUrl + `/Address/Search?query=${value}&limit=20`,
    );
  },
  getAddressGuids(value) {
    return axios.get(`/Address/${value}`, {});
  },

  getOwnershipTypes() {
    return axios.get(`/Nsi/OwnershipTypes`, {});
  },
  getFtg() {
    return axios.get(`/Nsi/GetFuncTypeGroups`, {});
  },
  getKosgus() {
    return axios.get(`/Nsi/Kosgus`, {});
  },
  getRso(resourceTypeId) {
    const body = {
      page: 1,
      count: 0,
      filterItems: [],
    };
    if (resourceTypeId) {
      const fItem = {
        fieldName: "resourceTypeId",
        condition: 0,
        value: resourceTypeId,
      };
      body.filterItems.push(fItem);
    }
    return axios.post(`/nsi/SystemDictionary/Rso/Items`, body);
  },
  getRsos() {
    return axios.get(`/Nsi/Rsos`, {});
  },
  //devices
  getDeviceTypes() {
    return axios.get(`/Nsi/GetDeviceTypes`, {});
  },
  getDeviceStatuses() {
    return axios.get(`/Nsi/GetDeviceStatuses`, {});
  },

  getCommunalResources(buildingId) {
    const body = {
      page: 1,
      count: 0,
      filterItems: [],
    };
    if (buildingId) {
      const fItem = {
        fieldName: "buildingId",
        condition: 0,
        value: buildingId,
      };
      body.filterItems.push(fItem);
    }
    return axios.post(`/nsi/SystemDictionary/ResourceType/Items`, body);
  },
  getCalibrationIntervals() {
    return axios.get(`/Nsi/GetCalibrationIntervals`, {});
  },
  getIndicationTypes() {
    return axios.get(`/Nsi/GetIndicationTypes`, {});
  },
  getRecordingPeriods() {
    return axios.get(`/Nsi/GetRecordingPeriods`, {});
  },
  //passport
  getEnergyEfficiencyClasses() {
    return axios.get(
      `/Nsi/dictionaryitems/EnergyEfficiencyClasses?sortProperty=OrderNum`,
      {},
    );
  },
  getPowerSupplyTypes() {
    return axios.get(`/Nsi/dictionaryitems/PowerSupplyTypes`, {});
  },
  getAccountingEquipment() {
    return axios.get(
      `/Nsi/dictionaryitems/ConsumptionAccountingEquipments`,
      {},
    );
  },
  getOperationModes() {
    return axios.get(`/Nsi/dictionaryitems/OperationModes`, {});
  },
  getEnergyTypes() {
    return axios.get(`/Nsi/dictionaryitems/EnergyTypes`, {});
  },
  getUartTypes() {
    return axios.get(`/Nsi/dictionaryitems/UartTypes`, {});
  },
  getUartFin() {
    return axios.get(`/Nsi/dictionaryitems/UartFundingSources`, {});
  },
  getHeatingControlSystemEquipment() {
    return axios.get(`/Nsi/dictionaryitems/HeatingControlSystemEquipment`, {});
  },
  getThermalProtectionEquipment() {
    return axios.get(`/Nsi/dictionaryitems/ThermalProtectionEquipment`, {});
  },

  // sp
  getGasSupplyObjects() {
    return axios.get(`/Nsi/dictionaryitems/GasSupplyObjects`, {});
  },
  getDefectReasons() {
    return axios.get(`/Nsi/dictionaryitems/DefectReasons?sortProperty=OrderNum`/*?sortProperty=Title`*/, {});
  },
  getLightingProblemTypes() {
    return axios.get(`/Nsi/dictionaryitems/LightingProblemTypes`, {});
  },
  getLightingObjects() {
    return axios.get(`/Nsi/dictionaryitems/LightingObjects`, {});
  },

  getGridTypes() {
    return axios.get("/nsi/gridtypes", {});
  },
  getIncidentStatuses() {
    return axios.get("/nsi/GetIncidentStatuses", {});
  },
  getObjectEntities() {
    return axios.get("/nsi/ObjectEntity", {});
  },
  getEventTypes() {
    return axios.get("/Nsi/EventTypes", {});
  },
  getGasketTypes() {
    return axios.get("/Nsi/GasketTypes", {});
  },
  getComplaintCodes() {
    return axios.get("/Nsi/GetComplaintCodes", {});
  },
  getWorkProgresses() {
    return axios.get("/Nsi/GetWorkProgresses", {});
  },
  getRepairCategories() {
    return axios.get("/Nsi/GetRepairCategories", {});
  },
  getWorkStatus() {
    return axios.get("/Nsi/GetWorkStatuses", {});
  },
  getActivityTypes() {
    return axios.get("/Nsi/GetActivityTypes", {});
  },
  getColdWaterSupplyObjects() {
    return axios.get("/Nsi/GetColdWaterSupplyObjects", {});
  },
  getPipeTypes() {
    return axios.get("/Nsi/PipeTypes", {});
  },
  getDefectExternalManifestation() {
    return axios.get("/Nsi/GetDefectExternalManifestation", {});
  },
  getHeatSupplyObjects() {
    return axios.get("/Nsi/GetHeatSupplyObjects", {});
  },
  getProducedWorks() {
    return axios.get("/Nsi/ProducedWorks", {});
  },
  getWorkTypes() {
    return axios.get("/Nsi/WorkTypes", {});
  },

  //filters
  getStatuses() {
    return axios.get(`/Nsi/GetWorkStatuses`, {});
  },
  getDistricts() {
    return axios.get(`/Nsi/Districts`, {});
  },
  getRestrictionNatures() {
    return axios.get(`/Nsi/RestrictionNatures`, {});
  },
  getLightingEquipmentLamps() {
    return axios.get(`/Nsi/dictionaryitems/LightingEquipmentLamps`, {});
  },
  getLightingEquipment() {
    return axios.get(`/Nsi/dictionaryitems/LightingEquipment`, {});
  },
  getLightingEquipmentLuminaireTypes() {
    return axios.get(
      `/Nsi/dictionaryitems/LightingEquipmentLuminaireTypes`,
      {},
    );
  },
  getLightningEquipmentLampLuminaireTypes() {
    return axios.get(`/Orgstructure/LightningEquipmentLampLuminaireType`, {});
  },

  getTypeGRBS(params) {
    return axios.post("nsi/SystemDictionary/GrbsType/Items", {
      ...params,
      page: params.page ?? 1,
      count: params.count ?? 0,
    });
  },

  getFuelType() {
    return axios.get(`/Nsi/GetFuelTypes`, {});
  },
};
